exports = module.exports = require("/home/kwok/projects/brewplanner/brewplanner-ui/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".bp-chip{display:flex;align-items:center;justify-content:space-between;font-size:11px;height:1em;line-height:2.1em;margin:.5em;padding:1em 3px 1em 1em;border-radius:2em;box-shadow:inset 0 3px 10px 0 lightgrey;background-color:#f6f6f6;color:#777}.bp-chip:hover{background-color:#f1f1f1}.bp-chip__text{font-size:1em;line-height:2.1em;text-shadow:1px 2px 1px lightgrey;font-weight:400;padding-right:12px}.bp-chip__icon .material-icons{font-size:1em;line-height:1em;margin-top:.5em;border-radius:50%;padding:.4em;border:solid 1.5px;color:#000}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Chips/Chips.scss
 ** module id = 238
 ** module chunks = 0
 **/